import { render } from "./consultation_at_diagnosis.vue?vue&type=template&id=794bcecc"
import script from "./consultation_at_diagnosis.vue?vue&type=script&lang=js"
export * from "./consultation_at_diagnosis.vue?vue&type=script&lang=js"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__